import { useState } from "react";
import Vector from "../Assets/Images/Welcome.png";
import Cursor from "../Assets/Images/cursor-left.svg";
import MobileHeaderImage from "../Assets/Images/Mobile-logo-auth.svg";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import { TextField, Button, InputAdornment, IconButton } from "@mui/material";
import axios from "axios";
import X from "../Assets/Icons/x-red.svg";
import Check from "../Assets/Icons/tick-dark.svg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Collapsible from "react-collapsible";
import WeddinglyLogo from "../Assets/Images/logo-auth.svg";

const ResetPasswordToken = () => {
  const { token } = useParams();

  const [PasswordValidation, setPasswordValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [PasswordRepeatValidation, setPasswordRepeatValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [Password, setPassword] = useState("");
  const [ShowPassword, setShowPassword] = useState(false);
  const [PasswordRepeat, setPasswordRepeat] = useState("");
  const [ShowPasswordRepeat, setShowPasswordRepeat] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordValidation({ hasError: false, errorMessage: "" });
  };

  const handlePasswordRepeatChange = (event) => {
    setPasswordRepeat(event.target.value);
    setPasswordRepeatValidation({ hasError: false, errorMessage: "" });
    // validateEntry(event.target.value);
  };
  const handleShowPassword = () => {
    setShowPassword(!ShowPassword);
  };

  const handleShowPasswordRepeat = () => {
    setShowPasswordRepeat(!ShowPasswordRepeat);
  };

  const saveNewPassword = () => {
    let Req = {
      method: "POST",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/api/account/reset-password/finish",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: token,
        newPassword: Password,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        goBackHome();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const goBackHome = () => {
    document.getElementById("back-to-login").click();
  };

  const inputClasses = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "15px",
      backgroundColor: "#fff1f2",
      border: "none",
      transition: "background-color 0.3s ease-in-out", // Smooth transition for background
      minWidth: "90% !important", // Updated
      maxWidth: "500px !important", // Updated
      width: "100%",
      fontSize: "20px",
      fontWeight: "600",
      paddingLeft: "10px",
      color: "#171717",
    },

    "& .MuiOutlinedInput-root.Mui-focused": {
      backgroundColor: "#f8e0e0", // Change background on focus
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important", // Remove outline border
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#FB47644D", // Default placeholder color
      transition: "color 0.3s ease-in-out, opacity 0.3s ease-in-out", // Smooth placeholder animation
    },

    "& .MuiInputBase-input:focus::placeholder": {
      color: "#9e7676",
      opacity: 0.9,
    },
  };

  return (
    <main className="auth-wrapper">
      <section className="auth-left-wrapper">
        <div className="auth-vector-container">
          <img className="auth-vector" alt="welcome" src={Vector} />
        </div>
        <img
          src={WeddinglyLogo}
          alt="weddingly logo"
          className="auth-weddingly-logo"
        />
      </section>
      <section className="auth-right-wrapper">
        <div className="section-head-action">
          <Link to="/" id="back-to-login" variant="body2">
            <img alt="" src={Cursor} />
            <p>Back to the login page</p>
          </Link>
        </div>
        <img alt="" className="mobile-header-image" src={MobileHeaderImage} />
        <form className="auth-form" onSubmit={handleSubmit}>
          <p className="form-head-text">Reset password</p>
          <Collapsible
            trigger={
              <TextField
                autoComplete="new-password" // Disable autofill
                fullWidth
                name="weddingly-password"
                id="password"
                placeholder="Password"
                type={ShowPassword ? "text" : "password"}
                variant="outlined"
                value={Password}
                onChange={handlePasswordChange}
                error={PasswordValidation.hasError}
                helperText={PasswordValidation.errorMessage}
                margin="normal"
                sx={{
                  ...inputClasses,
                  "& input[type='password']": {
                    ...(Password.length && {
                      fontFamily: "Verdana",
                      letterSpacing: "2px",
                    }),
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowPassword}
                        edge="end"
                        style={{ color: "#171717" }}
                      >
                        {ShowPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            }
          >
            <div className="password-validation-wrapper">
              <section
                className={
                  Password.length >= 8
                    ? "validation-row"
                    : "validation-row validation-row-error"
                }
              >
                <img alt="" src={Password.length >= 8 ? Check : X} />
                At least 8 characters
              </section>
              <section
                className={
                  /[A-Z]/.test(Password)
                    ? "validation-row"
                    : "validation-row validation-row-error"
                }
              >
                <img alt="" src={!/[A-Z]/.test(Password) ? X : Check} />
                At least one capital letter
              </section>
              <section
                className={
                  /\d/.test(Password)
                    ? "validation-row"
                    : "validation-row validation-row-error"
                }
              >
                <img alt="" src={!/\d/.test(Password) ? X : Check} />
                At least one digit
              </section>
              <section
                className={
                  /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(Password)
                    ? "validation-row"
                    : "validation-row validation-row-error"
                }
              >
                <img
                  alt=""
                  src={
                    !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(Password)
                      ? X
                      : Check
                  }
                />
                At least one special character
              </section>
            </div>
          </Collapsible>
          <TextField
            autoComplete="new-password" // Disable autofill
            fullWidth
            name="repeat-password"
            id="repeat-"
            placeholder="Password repeat"
            type={ShowPasswordRepeat ? "text" : "password"}
            variant="outlined"
            value={PasswordRepeat}
            onChange={handlePasswordRepeatChange}
            error={PasswordRepeatValidation.hasError}
            helperText={PasswordRepeatValidation.errorMessage}
            margin="normal"
            sx={{
              ...inputClasses,
              "& input[type='password']": {
                ...(PasswordRepeat.length && {
                  fontFamily: "Verdana",
                  letterSpacing: "2px",
                }),
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleShowPasswordRepeat}
                    edge="end"
                    style={{ color: "#171717" }}
                  >
                    {ShowPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <div className="reset-pass-actions">
            <Button
              type="submit"
              variant="contained"
              disabled={
                Password !== PasswordRepeat ||
                Password.length === 0 ||
                !(
                  Password.length >= 8 &&
                  /[A-Z]/.test(Password) &&
                  /\d/.test(Password) &&
                  /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(Password)
                )
                  ? true
                  : false
              }
              onClick={() => saveNewPassword()}
              sx={{
                backgroundColor: "#FB4764",
                "&:hover": {
                  backgroundColor: "#FB4764",
                },
                height: "56px",
                fontSize: "25px",
                fontWeight: "600",
                display: "flex",
                color: "#ffff",
                boxShadow: "",
                marginTop: "10px",
                gridGap: "8px",
                textTransform: "none", // Prevent text from being all caps,
                borderRadius: "15px",
                minWidth: "90% !important",
                maxWidth: "500px !important",
                width: "100%",
                "&.Mui-disabled": {
                  backgroundColor: "#DEDEDE",
                  cursor: "not-allowed",
                  color: "#1D1B201A",
                },
              }}
            >
              Change password
            </Button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default ResetPasswordToken;
